import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 17l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v8","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}]]

const IconBookmarkMinus = createReactComponent('outline', 'bookmark-minus', 'BookmarkMinus', __iconNode);

export default IconBookmarkMinus;